import { useEffect, useRef } from "react";
import { useReplay } from "./ReplayContext";

function shortLabel(label: string, max = 56): string {
  const trimmed = label.trim();
  if (trimmed.length <= max) return trimmed;
  return `${trimmed.slice(0, max - 1)}…`;
}

export function ReplayTimeline() {
  const { stepStates, playing, selected } = useReplay();
  const activeRef = useRef<HTMLLIElement | null>(null);
  const stepsList = selected?.steps ?? [];

  useEffect(() => {
    if (playing && activeRef.current) {
      activeRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [playing, stepStates]);

  if (!selected || !stepsList.length) return null;

  return (
    <div className={`replay-panel${playing ? " replay-panel--live" : ""}`}>
      <p className="muted replay-panel-sub">{selected.name}</p>
      <ol className="replay-timeline" aria-label="Scenario steps">
        {stepsList.map((step, i) => {
          const state = stepStates[i] ?? "pending";
          const isActive = playing && state === "active";
          return (
            <li
              key={step.index}
              ref={isActive ? activeRef : undefined}
              className={`replay-step replay-step--${state}${isActive ? " replay-step--pulse" : ""}`}
            >
              <span className="replay-bubble" title={step.label} aria-hidden />
              <span className="replay-step-label" title={step.label}>
                {shortLabel(step.label)}
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
